import { PALETTE } from './primitives';

// data: [{ name, value }]
export const SiteBars = ({ data = [], barsIn = true, testidPrefix = 'site-item', max = 8 }) => {
  const largest = Math.max(...data.slice(0, max).map(item => item.value), 1);
  return (
    <div className="space-y-2.5">
      {data.slice(0, max).map((s, i) => {
        const pct = (s.value / largest) * 100;
        const color = PALETTE[i % PALETTE.length];
        return (
          <div key={s.name} data-testid={`${testidPrefix}-${i}`} className="group">
            <div className="flex items-center justify-between text-xs mb-1">
              <span className="text-foreground font-medium truncate">{s.name}</span>
              <span className="text-muted-foreground font-mono">
                {s.value}
              </span>
            </div>
            <div className="h-2 bg-muted/50 rounded-full overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-700 ease-out"
                style={{ width: `${barsIn ? pct : 0}%`, backgroundColor: color }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
